import { apiSlice } from "./index";

export const authApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    uploadImage: builder.mutation({
      query: ({ formData, url }) => ({
        url: url,
        method: "POST",
        body: formData,
      }),
    }),

    updateImage: builder.mutation({
      query: ({ formData, url }) => ({
        url: url,
        method: "PATCH",
        body: formData,
      }),
    }),

    createItem: builder.mutation({
      query: ({ credentials, url }) => ({
        url: url,
        method: "POST",
        body: { ...credentials },
        headers: {
          "Content-Type": "application/json",
        },
      }),
    }),

    updateItem: builder.mutation({
      query: ({ credentials, url }) => ({
        url: `${url}`,
        method: "PATCH",
        body: { ...credentials },
      }),
    }),

    replaceItem: builder.mutation({
      query: ({ credentials, url }) => ({
        url: `${url}`,
        method: "PUT",
        body: { ...credentials },
      }),
    }),

    deleteItem: builder.mutation({
      query: ({ url }) => ({
        url: `${url}`,
        method: "DELETE",
      }),
    }),

    getItems: builder.query({
      query: (url) => ({
        url: url,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useCreateItemMutation,
  useUpdateItemMutation,
  useReplaceItemMutation,
  useUploadImageMutation,
  useDeleteItemMutation,
  useGetItemsQuery,
  useLazyGetItemsQuery,
  useUpdateImageMutation,
} = authApiSlice;
